import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import { getDashboardMetrics } from '../../services/api/dashboard-metrics-service';
import WeeklyIncidenceChart from '../../components/Charts/weekly-incidence-status';
import MonthlyChart from '../../components/Charts/monthly-chart';

// New Dashboard Components
import KPICards from '../../components/Dashboard/KPICards';
import StatusDistributionChart from '../../components/Dashboard/StatusDistributionChart';
import MonthlyTrendsChart from '../../components/Dashboard/MonthlyTrendsChart';
import QuickStats from '../../components/Dashboard/QuickStats';
import YearlyComparisonCard from '../../components/Dashboard/YearlyComparisonCard';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    marginBottom: theme.spacing(3),
    overflow: 'hidden',
  },
  chartContainer: {
    marginBottom: theme.spacing(3),
  },
  metricsSection: {
    marginBottom: theme.spacing(3),
  },
}));

const Main = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [metrics, setMetrics] = useState(null);

  const fetchMetrics = async () => {
    try {
      const response = await getDashboardMetrics();
      setMetrics(response.data);
    } catch (e) {
      console.error('Error fetching metrics:', e);
    }
  }

  useEffect(() => {
    fetchMetrics();
  }, []); // eslint-disable-line

  return (
    <div className={classes.root}>
      <Container maxWidth={'xl'} disableGutters>
        {/* KPI Cards Section */}
        <div className={classes.metricsSection}>
          <Toolbar>
            <Typography variant="h5" component="h2">
              {t('dashboard.metrics_overview')}
            </Typography>
          </Toolbar>
          <KPICards metrics={metrics} />
        </div>

        {/* Charts Section */}
        <Grid container spacing={3}>
          {/* Weekly Status Chart */}
          <Grid item xs={12} lg={3} md={6}>
            <Paper className={classes.chartContainer}>
              <WeeklyIncidenceChart />
            </Paper>
          </Grid>

          {/* Quick Stats */}
          <Grid item xs={12} lg={3} md={6}>
            <QuickStats data={metrics?.thisWeekNew} />
          </Grid>

          {/* Status Distribution */}
          <Grid item xs={12} lg={3} md={6}>
            <StatusDistributionChart
              title={t('dashboard.incidence_status')}
              data={metrics?.incidenceStatusDistribution}
              totalLabel={t('dashboard.total_incidences')}
            />
          </Grid>

          {/* Yearly Comparison */}
          <Grid item xs={12} lg={3} md={6}>
            <YearlyComparisonCard metrics={metrics} />
          </Grid>

          {/* Monthly Trends Chart */}
          <Grid item xs={12}>
            <MonthlyTrendsChart data={metrics?.monthlyTrends} />
          </Grid>

          {/* Monthly Chart - Full Width */}
          <Grid item xs={12}>
            <Paper className={classes.chartContainer}>
              <MonthlyChart />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
};

export default Main;
